import { ContentsHeader, PrimaryButton } from "@graffer-inc/console-design-kit";
import { useHistory } from "react-router-dom";
import { SmartApplyR } from "../../route";

export const ProcedureAssignmentSettingRuleSetContentHeader: React.FC /* TODO: <具体的な型を入れる> */ =
  (/* TODO: 具体的な引数を入れる */) => {
    const history = useHistory();
    return (
      <ContentsHeader
        title="申請振り分け設定一覧"
        border={false}
        buttons={[
          [
            // TODO: permission 追加後に RBACHidden をアンコメントする
            //   <RBACHidden
            //     key={"rulesetsRBACHidden"}
            //     requirePermissions={"rulesets.create"}
            //   >
            <div
              key={"rulesets"} // TODO: key は RBACHidden に付け替える
              className="level-item"
            >
              <PrimaryButton
                text={"新規申請振り分け設定作成"}
                onClick={() => {
                  history.push(
                    SmartApplyR.AssignmentSettingRulesetCreate.link({}),
                  );
                }}
                icon={"PlusCircleIcon"}
              />
            </div>,
            //   </RBACHidden>,
          ],
        ]}
      />
    );
  };
